<ng-container *ngIf="isPopUp; else notPopUp">
  <div class="ipm-onboarding-flow">
  <div class="onboarding-container">
    <!-- Close Button -->
    <!-- <div class="ipm-close-icon" (click)="closeByDeviceType()">
      <i class="pi pi-times"></i>
    </div> -->

    <!-- Desktop View - Hidden on mobile container -->
    <div class="desktop-view">
      <owl-carousel-o [options]="customOptions" #desktopCarousel (changed)="onSlideChanged($event)">
        <ng-container *ngFor="let slide of filteredOnboardingFlowData ;let i = index">
          <ng-template carouselSlide>
            <div class="content-section">
              <div class="text-content">
                <div class="text">
                  <div class="slide-title">
                    <span [innerHTML]="slide.title"></span><span *ngIf="i === 0 && currrentType === 'buyer'"><img src="assets/imgs/Vibe.svg" alt="vibe."/></span>
                  </div>
                  <p class="slide-description">{{ slide.description }}</p>
                  <p class="slide-description" *ngIf="slide.subDescription">{{ slide.subDescription }}</p>
                  <p class="slide-description" *ngIf="slide.subDescriptionII">{{ slide.subDescriptionII }}</p>
                </div>
              </div>
              <div class="image-section">
                <img [src]="(userRole !== 'producer' && slide.buyerImageUrl) ? slide.buyerImageUrl : (slide.imageUrl || 'assets/imgs/beats-marketplace.png')" 
                     [alt]="slide.title" 
                     class="slide-image">
              </div>
            </div>
          </ng-template>
        </ng-container>
      </owl-carousel-o>
      <div class="custom-nav-btns">
        <button class="owl-nav-btn owl-prev" 
                [disabled]="currentSlide === 0" 
                (click)="goToPrevSlide(desktopCarousel)">
          Prev
        </button>
        <button *ngIf="!isLastSlide" class="owl-nav-btn owl-next" 
                [disabled]="currentSlide === filteredOnboardingFlowData.length - 1" 
                (click)="goToNextSlide(desktopCarousel)">
          Next
        </button>
        <button *ngIf="isLastSlide" class="owl-nav-btn owl-continue" (click)="continueToDashboard()">
          Continue
        </button>
      </div>
    </div>

    <!-- Mobile View - Hidden on desktop container -->
    <div class="mobile-view">
      <owl-carousel-o [options]="mobileOptions" #mobileCarousel (changed)="onSlideChanged($event)">
        <ng-container *ngFor="let slide of filteredOnboardingFlowData; let i = index">
          <ng-template carouselSlide>
            <div class="mobile-content-section">
              <div class="mobile-text-content">
                <div class="mobile-title">
                  <span [innerHTML]="slide.title"></span><span *ngIf="i === 0 && currrentType === 'buyer'"><img src="assets/imgs/Vibe.svg" alt="vibe."/></span>
                </div>
                <p class="mobile-description">{{ slide.description }}</p>
                <p class="mobile-description" *ngIf="slide.subDescription">{{ slide.subDescription }}</p>
                <p class="mobile-description" *ngIf="slide.subDescriptionII">{{ slide.subDescriptionII }}</p>
              </div>
              <div class="mobile-image-section">
                <img [src]="slide.imageUrl" 
                     [alt]="slide.title" 
                     class="mobile-slide-image">
              </div>
            </div>
          </ng-template>
        </ng-container>
      </owl-carousel-o>
      <div class="custom-nav-btns">
        <button class="owl-nav-btn owl-prev" 
                [disabled]="currentSlide === 0" 
                (click)="goToPrevSlide(mobileCarousel)">
          Prev
        </button>
        <button *ngIf="!isLastSlide" class="owl-nav-btn owl-next" 
                [disabled]="currentSlide === filteredOnboardingFlowData.length - 1" 
                (click)="goToNextSlide(mobileCarousel)">
          Next
        </button>
        <button *ngIf="isLastSlide" class="owl-nav-btn owl-continue" (click)="continueToDashboard()">
          Continue
        </button>
      </div>
    </div>
  </div>
</div>
</ng-container>

<ng-template #notPopUp>
  <div class="features-section-landing">
    <div class="ipm-container">
      <div class="heading">
        <div class="main-heading">Your Trusted <span>Creative</span> Partner</div>
        <!-- <div class="sub-heading">Earn from every sound you create</div> -->
      </div>

      <!-- Desktop Feature Section -->
      <div class="feature desktop-feature">        
        <div class="btns-img">
          <div class="btns">
            <button *ngFor="let slide of landingFeaturesData; let i = index" 
                    class="btn"
                    [class.active]="activeButton === i"
                    (click)="handleBtnClick(i)">
              <div class="btn-icon">
                <img [src]="slide.iconSvg" alt="{{slide.title}} icon" />
              </div>
              <div class="btn-text">
                <div>{{slide.title}}</div>
                <p>{{slide.description}}</p>
              </div>
            </button>
            <button class="cta-btn" (click)="handleCtaClick()">
              {{ isLoggedIn ? 'Explore Now' : 'Get Started'}}
            </button>
          </div>
          
          <div class="img-section">
            <div class="img-container"
                 (touchstart)="onTouchStart($event)"
                 (touchend)="onTouchEnd($event)"
                 (mousedown)="onMouseDown($event)"
                 (mousemove)="onMouseMove($event)"
                 (mouseup)="onMouseUp($event)"
                 (mouseleave)="onMouseLeave()">
              <!-- Previous image sliding out -->
              <div class="img-wrapper img-previous" *ngIf="animatingFeature"
                   [class.slide-out-to-left]="slideDirection === 'left'"
                   [class.slide-out-to-right]="slideDirection === 'right'">
                <ng-container *ngIf="!landingFeaturesData[previousButton].videoUrl; else prevVideoDesktop">
                  <img [src]="(userRole !== 'producer' && landingFeaturesData[previousButton].buyerImageUrl) ? landingFeaturesData[previousButton].buyerImageUrl : (landingFeaturesData[previousButton].imageUrl)" 
                       alt="previous image">
                </ng-container>
                <ng-template #prevVideoDesktop>
                  <div class="ipm-dh-video-panel" style="width: 100%; height: 100%;">
                    <div class="ipm-dh-video-wrapper">
                      <div class="ipm-dh-video-toggle-bottom" [class.en-active]="selectedVideoLanguage === 'en'" role="tablist" aria-label="Video language">
                        <button type="button" class="ipm-dh-video-tab" [class.active]="selectedVideoLanguage === 'hn'" (click)="setVideoLanguage('hn')" [attr.aria-pressed]="selectedVideoLanguage === 'hn'">Hn</button>
                        <button type="button" class="ipm-dh-video-tab" [class.active]="selectedVideoLanguage === 'en'" (click)="setVideoLanguage('en')" [attr.aria-pressed]="selectedVideoLanguage === 'en'">En</button>
                      </div>
                      <iframe *ngIf="activeVideoUrl" [src]="activeVideoUrl" [title]="selectedVideoLanguage === 'hn' ? 'Beat22 Hindi video' : 'Beat22 English video'" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                  </div>
                </ng-template>
              </div>
              <!-- Current image sliding in or static -->
              <div class="img-wrapper img-current"
                   [class.slide-in-from-right]="slideDirection === 'left' && animatingFeature"
                   [class.slide-in-from-left]="slideDirection === 'right' && animatingFeature">
                <ng-container *ngIf="!landingFeaturesData[activeButton].videoUrl; else currVideoDesktop">
                  <img [src]="(userRole !== 'producer' && landingFeaturesData[activeButton].buyerImageUrl) ? landingFeaturesData[activeButton].buyerImageUrl : (landingFeaturesData[activeButton].imageUrl)" 
                       alt="current image">
                </ng-container>
                <ng-template #currVideoDesktop>
                  <div class="ipm-dh-video-panel" style="width: 100%; height: 100%;">
                    <div class="ipm-dh-video-wrapper">
                      <div class="ipm-dh-video-toggle-bottom" [class.en-active]="selectedVideoLanguage === 'en'" role="tablist" aria-label="Video language">
                        <button type="button" class="ipm-dh-video-tab" [class.active]="selectedVideoLanguage === 'hn'" (click)="setVideoLanguage('hn')" [attr.aria-pressed]="selectedVideoLanguage === 'hn'">Hn</button>
                        <button type="button" class="ipm-dh-video-tab" [class.active]="selectedVideoLanguage === 'en'" (click)="setVideoLanguage('en')" [attr.aria-pressed]="selectedVideoLanguage === 'en'">En</button>
                      </div>
                      <iframe *ngIf="activeVideoUrl" [src]="activeVideoUrl" [title]="selectedVideoLanguage === 'hn' ? 'Beat22 Hindi video' : 'Beat22 English video'" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Mobile Feature Section -->
      <div class="feature mobile-feature">
        <!-- Tab Navigation -->
        <div class="mobile-tabs" #mobileTabs>
          <button *ngFor="let slide of landingFeaturesData; let i = index" 
                  class="mobile-tab"
                  [class.active]="activeButton === i"
                  (click)="handleBtnClick(i)">
            <div class="tab-icon">
              <img [src]="slide.iconSvg" alt="{{slide.title}} icon" />
            </div>
            <div class="tab-text">{{slide.title}}</div>
          </button>
        </div>

        <!-- Feature Content -->
        <div class="mobile-feature-content">
          <div class="feature-description-cta">
            <div class="feature-description">
              {{landingFeaturesData[activeButton].description}}
            </div>
            <!-- <div class="cta-btn"><button (click)="handleCtaClick()">
              {{ isLoggedIn ? 'Explore Now' : 'Get Started'}}
            </button></div> -->
          </div>
          
          <div class="feature-image">
            <div class="img-container"
                 (touchstart)="onTouchStart($event)"
                 (touchend)="onTouchEnd($event)"
                 (mousedown)="onMouseDown($event)"
                 (mousemove)="onMouseMove($event)"
                 (mouseup)="onMouseUp($event)"
                 (mouseleave)="onMouseLeave()">
              <!-- Previous image sliding out -->
              <div class="img-wrapper img-previous" *ngIf="animatingFeature"
                   [class.slide-out-to-left]="slideDirection === 'left'"
                   [class.slide-out-to-right]="slideDirection === 'right'">
                <ng-container *ngIf="!landingFeaturesData[previousButton].videoUrl; else prevVideoMobile">
                  <img [src]="(userRole !== 'producer' && landingFeaturesData[previousButton].buyerImageUrl) ? landingFeaturesData[previousButton].buyerImageUrl : (landingFeaturesData[previousButton].imageUrl)" 
                       alt="previous image">
                </ng-container>
                <ng-template #prevVideoMobile>
                  <div class="ipm-dh-video-panel" style="width: 100%; height: 100%;">
                    <div class="ipm-dh-video-wrapper">
                      <div class="ipm-dh-video-toggle-bottom" [class.en-active]="selectedVideoLanguage === 'en'" role="tablist" aria-label="Video language">
                        <button type="button" class="ipm-dh-video-tab" [class.active]="selectedVideoLanguage === 'hn'" (click)="setVideoLanguage('hn')" [attr.aria-pressed]="selectedVideoLanguage === 'hn'">Hn</button>
                        <button type="button" class="ipm-dh-video-tab" [class.active]="selectedVideoLanguage === 'en'" (click)="setVideoLanguage('en')" [attr.aria-pressed]="selectedVideoLanguage === 'en'">En</button>
                      </div>
                      <iframe *ngIf="activeVideoUrl" [src]="activeVideoUrl" [title]="selectedVideoLanguage === 'hn' ? 'Beat22 Hindi video' : 'Beat22 English video'" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                  </div>
                </ng-template>
              </div>
              <!-- Current image sliding in or static -->
              <div class="img-wrapper img-current"
                   [class.slide-in-from-right]="slideDirection === 'left' && animatingFeature"
                   [class.slide-in-from-left]="slideDirection === 'right' && animatingFeature">
                <ng-container *ngIf="!landingFeaturesData[activeButton].videoUrl; else currVideoMobile">
                  <img [src]="(userRole !== 'producer' && landingFeaturesData[activeButton].buyerImageUrl) ? landingFeaturesData[activeButton].buyerImageUrl : (landingFeaturesData[activeButton].imageUrl)" 
                       alt="current image">
                </ng-container>
                <ng-template #currVideoMobile>
                  <div class="ipm-dh-video-panel" style="width: 100%; height: 100%;">
                    <div class="ipm-dh-video-wrapper">
                      <div class="ipm-dh-video-toggle-bottom" [class.en-active]="selectedVideoLanguage === 'en'" role="tablist" aria-label="Video language">
                        <button type="button" class="ipm-dh-video-tab" [class.active]="selectedVideoLanguage === 'hn'" (click)="setVideoLanguage('hn')" [attr.aria-pressed]="selectedVideoLanguage === 'hn'">Hn</button>
                        <button type="button" class="ipm-dh-video-tab" [class.active]="selectedVideoLanguage === 'en'" (click)="setVideoLanguage('en')" [attr.aria-pressed]="selectedVideoLanguage === 'en'">En</button>
                      </div>
                      <iframe *ngIf="activeVideoUrl" [src]="activeVideoUrl" [title]="selectedVideoLanguage === 'hn' ? 'Beat22 Hindi video' : 'Beat22 English video'" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>

        <div class="mobile-cta">
          <button class="cta-btn" (click)="handleCtaClick()">
            {{ isLoggedIn ? 'Explore Now' : 'Get Started'}}
          </button>
        </div>
        <!-- Pagination Dots -->
        <div class="mobile-dots">
          <span *ngFor="let slide of landingFeaturesData; let i = index" 
                class="dot"
                [class.active]="activeButton === i"
                (click)="handleBtnClick(i)">
          </span>
        </div>
      </div>
    </div>
  </div>
</ng-template>